import './Footer.css';

/**
 * Footer Component
 * 
 * Application footer with copyright and links
 */
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-text">
          © {currentYear} TUI Group. All rights reserved.
        </p>
        <div className="footer-links">
          <a href="#" className="footer-link">Privacy Policy</a>
          <span className="footer-divider">•</span>
          <a href="#" className="footer-link">Terms of Service</a>
          <span className="footer-divider">•</span>
          <a href="#" className="footer-link">Support</a>
        </div>
      </div>
    </footer>
  );
}
